import styled from 'styled-components'
import { DealIcon } from '@shipt/design-system-icons'
import { ProductDetailPromotionCallout } from '@/features/shop/components/ProductDetail/ProductDetailPromotionCallout'
import { ProductDetailCoupon } from '@/features/shop/components/ProductDetail/ProductDetailCoupon'
import { Body } from '@shipt/design-system-typography'
import { type Product } from '@/features/shop/services/Product/types'
import { type CouponClippedState } from '@/features/shop/services/Coupons/hooks'

type Props = {
  coupon:
    | {
        couponId: string
        description?: string
        summary?: string
        expiredAt: string
        faceValue: number
        appliedProductQty: number
      }
    | undefined
  // product can be the parent product of the displayed product or the displayed product itself
  product: Product
  // selectedProduct is product that is displayed on the PDP
  selectedProduct: Product
  productQuantity: number
  couponClippedState: CouponClippedState
}

export const ProductDetailPromotionAndCoupon = ({
  coupon,
  product,
  selectedProduct,
  productQuantity,
  couponClippedState,
}: Props) => {
  const { cpgPromotion, line_item_promotion } = product
  const { bogo, oos } = selectedProduct
  const showLineItemPromotion = Boolean(line_item_promotion.effect)
  const showCoupon = coupon && !oos && !cpgPromotion && !showLineItemPromotion

  return (
    <>
      {!!bogo && (
        <BogoWrapper concept="feedback" feedbackType="promotion" strong>
          <PromotionSaleFilledIcon inherit size="sm" />
          BUY 1, GET 1 FREE
        </BogoWrapper>
      )}
      {!!showLineItemPromotion && !!line_item_promotion.category_id && (
        <ProductDetailPromotionCallout
          promotion={line_item_promotion}
          description={line_item_promotion.display_description}
        />
      )}
      {!!cpgPromotion && !!showLineItemPromotion && <Spacer />}
      {!!cpgPromotion && <ProductDetailPromotionCallout promotion={cpgPromotion} />}
      {!!showCoupon && (
        <ProductDetailCoupon
          coupon={coupon}
          product={product}
          productQuantity={productQuantity}
          couponClippedState={couponClippedState}
        />
      )}
    </>
  )
}

const Spacer = styled.div`
  height: 15px;
  width: 100%;
`

const BogoWrapper = styled(Body)`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`

const PromotionSaleFilledIcon = styled(DealIcon)`
  margin-right: 4px;
`
